import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const SITE_ORIGIN =
  typeof window !== "undefined" ? window.location.origin : "";

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("wsbf_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export function apiErr(e, fallback = "Something went wrong") {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((x) => x?.msg || x?.message || JSON.stringify(x)).join(" ");
  // Structured backend errors: {code, message, ...} or FastAPI validation {msg}
  if (typeof d === "object")
    return d.message || d.msg || d.detail || d.error || fallback;
  return String(d);
}

export function qrUrl(data) {
  return `${API}/qr?data=${encodeURIComponent(data)}`;
}

// Resolve a stored avatar_url (e.g. "/api/avatars/<id>?v=..") to a fully-qualified
// src the browser can load. Returns null when there is no uploaded avatar.
export function avatarSrc(url) {
  if (!url) return null;
  if (/^https?:\/\//.test(url)) return url;
  return `${process.env.REACT_APP_BACKEND_URL}${url}`;
}
